module.exports = __webpack_public_path__ + "static/img/osde-3.75a325a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/osde-3.jpg
// module id = HtvU
// module chunks = 1